import { FC } from "react";

import { IButtonProps } from "./types";
import { BaseButton } from "./styles";

/**
 * @param {Object} props - Component props
 * @param {IButtonStyleType} [$variant] [default: "primary"] - Button variant from theme;
 * @param {IInputButtonSize} [$size] [default: "medium"] - Button size from theme;
 * @param {boolean} [$isMaximized] [default: false] - Button is maximized (width: 100%; max-width: 360px);
 * @param {boolean} [$isParentWidth] [default: false] - Button is parent width (width: 100%; max-width: 100%);
 * @param {boolean} [disabled] [default: false] - Button is disabled;
 * @param {ElementSpacingType} [$p] - Padding for the button ($pt, $pb, $pl, $pr);
 * @param {ElementSpacingType} [$m] - Margin for the button ($mb, $mt, $ml, $mr);
 * @param {React.HTMLAttributes<HTMLButtonElement>} [...rest] Default props for HTML button element;
 */
const Button: FC<IButtonProps> = (props: IButtonProps) => {
  return <BaseButton {...props} />;
};

export default Button;
